import {ReactComponent as CloseIcon} from "./closeWhite.svg";

const CloseWhiteicon = () => {
    return (
        <div className='close_button'><CloseIcon className='icon' /></div>
    )
}
export default CloseWhiteicon
